'use es6';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import actionTypes from '../constants/actionTypes';
import requestStatusType from '../constants/requestStatusTypes';
const {
  GET_DASHBOARDS_REQUESTED,
  GET_DASHBOARDS_SUCCEEDED,
  GET_DASHBOARDS_FAILED
} = actionTypes;
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusType;
const initialState = fromJS({
  status: {
    getDashboards: UNINITIALIZED,
    getDashboard: UNINITIALIZED,
    updateDashboard: UNINITIALIZED,
    deleteDashboard: UNINITIALIZED
  },
  dashboards: {}
});
export default handleActions({
  [GET_DASHBOARDS_REQUESTED](state) {
    return state.setIn(['status', 'getDashboards'], PENDING);
  },
  [GET_DASHBOARDS_SUCCEEDED](state, {
    payload: dashboards
  }) {
    return state.setIn(['status', 'getDashboards'], SUCCEEDED).set('dashboards', dashboards);
  },
  [GET_DASHBOARDS_FAILED](state, {
    payload: dashboards
  }) {
    return state.setIn(['status', 'getDashboards'], FAILED).set('dashboards', dashboards);
  }
}, initialState);